jQuery(document).ready(function(){
    $(".accordion").each(function() {
        let accordion = $(this);
        let titleArea = $(this).find(".accordion__item--title");

        $(accordion).find(".accordion__item--description-container").hide();

        $(titleArea).click(function(){
            $(accordion).find(".accordion__item--description-container").slideUp("slow");
            $(accordion).find(".accordion__item--title .arrow").removeClass("rotate-arrow-down");
            $(accordion).find(".accordion__item").removeClass("accordion-item-active");
            if ($(this).siblings(".accordion__item--description-container")[0].style.display !== 'none') {
                $(this).siblings(".accordion__item--description-container").slideUp("slow");
                $(this).find(".arrow").removeClass("rotate-arrow-down");
                $(this).parent(".accordion__item").removeClass("accordion-item-active");
            } else if ($(this).siblings(".accordion__item--description-container")[0].style.display === 'none') {
                $(this).siblings(".accordion__item--description-container").slideDown("slow");
                $(this).find(".arrow").addClass("rotate-arrow-down");
                $(this).parent(".accordion__item").addClass("accordion-item-active");
            }
        });

        if ($(accordion).hasClass("reveal-first-item")) {
            let firstAccordionItem = $(this).find(".accordion__item").first();
            firstAccordionItem.find(".accordion__item--title").click();
        }
    })
})